import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import MyBranchState from "@NA/Store/Data/ADIMyBranchState";

type HandlerType = CustomApiHandler<any, MyBranchState>;

export const PopulateMyBranchConfigParam: HandlerType = props => {
    props.apiParameter = props.parameter;
    props.dispatch({
        type: "Custom/MyBranch/PopulateConfigParam",
    });
};

export const CleanMyBranchConfig: HandlerType = props => {
    props.dispatch({
        type: "Custom/MyBranch/CleanConfig",
    });
};

export const SetMyBranchConfig: HandlerType = props => {
    props.dispatch({
        type: "Custom/MyBranch/SetConfig",
        result: props.apiParameter,
    });
};

export const chain = [PopulateMyBranchConfigParam, CleanMyBranchConfig, SetMyBranchConfig];

const setMyBranch = createHandlerChainRunner(chain, "SetMyBranch");

export default setMyBranch;
